module.exports = __webpack_public_path__ + "img/20191231154506242.d3b62959.jpg";